module.exports = __webpack_public_path__ + "img/img10.35e8ea0b.jpg";